// If you are adding a term to the Source glossary,
// please add a member of the Data team to your PR

// Due to overlap between the name property of Screen events and the
// source property of UI, Track, and Operational events, we group
// them together in this file.
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329599/Analytics+Lesson+1+-+Event+Types

// More information on naming screens:
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329341/Screen+Events

// Inline dialogs (popovers) are components that pop up over the UI and provides additional functionality that involves user interaction.
const inlineDialogs = {
  aboutThisBoardAdminListInlineDialog: 'aboutThisBoardAdminListInlineDialog',
  actionableTaskInlineDialog: 'actionableTaskInlineDialog',
  addListInlineDialog: 'addListInlineDialog',
  addToEnterpriseInlineDialog: 'addToEnterpriseInlineDialog',
  adminListInlineDialog: 'adminListInlineDialog',
  allBoardMembersInlineDialog: 'allBoardMembersInlineDialog',
  atlassianAccountMigrationChangeEmailInlineDialog:
    'atlassianAccountMigrationChangeEmailInlineDialog',
  attachmentGetPowerUpInlineDialog: 'attachmentGetPowerUpInlineDialog',
  attachmentsGetPowerUpUpgradeInlineDialog:
    'attachmentsGetPowerUpUpgradeInlineDialog',
  autoEnableCalendarInlineDialog: 'autoEnableCalendarInlineDialog',
  avatarChangeInlineDialog: 'avatarChangeInlineDialog',
  boardBackgroundPromptInlineDialog: 'boardBackgroundPromptInlineDialog',
  boardMenuDrawerEnterpriseUpsellInlineDialog:
    'boardMenuDrawerEnterpriseUpsellInlineDialog',
  boardOrganizationInlineDialog: 'boardOrganizationInlineDialog',
  boardsMenuInlineDialog: 'boardsMenuInlineDialog',
  boardViewsInlineDialog: 'boardViewsInlineDialog',
  cardComposerLabelSelectorInlineDialog:
    'cardComposerLabelSelectorInlineDialog',
  cardComposerMemberSelectorInlineDialog:
    'cardComposerMemberSelectorInlineDialog',
  cardComposerMenuInlineDialog: 'cardComposerMenuInlineDialog',
  cardComposerPositionSelectorInlineDialog:
    'cardComposerPositionSelectorInlineDialog',
  changeBillingContactInlineDialog: 'changeBillingContactInlineDialog',
  changeBoardOrganizationInlineDialog: 'changeBoardOrganizationInlineDialog',
  boardSidebarPupInlineDialog: 'boardSidebarPupInlineDialog',
  changeBoardPermissionsInlineDialog: 'changeBoardPermissionsInlineDialog',
  changeBoardVisibilityInlineDialog: 'changeBoardVisibilityInlineDialog',
  changeCreditCardInlineDialog: 'changeCreditCardInlineDialog',
  changeEmailInlineDialog: 'changeEmailInlineDialog',
  changeEmailSubmittedInlineDialog: 'changeEmailSubmittedInlineDialog',
  changeEmailWarningInlineDialog: 'changeEmailWarningInlineDialog',
  changeInvoiceDetailsInlineDialog: 'changeInvoiceDetailsInlineDialog',
  changeOrgInlineDialog: 'changeOrgInlineDialog',
  copyCardInlineDialog: 'copyCardInlineDialog',
  copyBoardInlineDialog: 'copyBoardInlineDialog',
  copyListInlineDialog: 'copyListInlineDialog',
  changeTeamAvatarDialog: 'changeTeamAvatarDialog',
  createCardFromTemplateInlineDialog: 'createCardFromTemplateInlineDialog',
  createMultipleCardsInlineDialog: 'createMultipleCardsInlineDialog',
  datePickerInlineDialog: 'datePickerInlineDialog',
  emailHygieneRemoveSecondaryEmailsInlineDialog:
    'emailHygieneRemoveSecondaryEmailsInlineDialog',
  emailHygieneChangeEmailInlineDialog: 'emailHygieneChangeEmailInlineDialog',
  emailToBoardSettingsInlineDialog: 'emailToBoardSettingsInlineDialog',
  exportBoardInlineDialog: 'exportBoardInlineDialog',
  inlineCardComposerInlineDialog: 'inlineCardComposerInlineDialog',
  inlineListComposerInlineDialog: 'inlineListComposerInlineDialog',
  inviteToBoardInlineDialog: 'inviteToBoardInlineDialog',
  inviteToTeamInlineDialog: 'inviteToTeamInlineDialog',
  linkCopyInlineDialog: 'linkCopyInlineDialog',
  listLimitInlineDialog: 'listLimitInlineDialog',
  listMenuInlineDialog: 'listMenuInlineDialog',
  miniProfileInlineDialog: 'miniProfileInlineDialog',
  moonshotWelcomeInlineDialog: 'moonshotWelcomeInlineDialog',
  moonshotPaymentScreen: 'moonshotPaymentScreen',
  moreMenuShareInlineDialog: 'moreMenuShareInlineDialog',
  moveAllCardsInListInlineDialog: 'moveAllCardsInListInlineDialog',
  moveListInlineDialog: 'moveListInlineDialog',
  newBoardHelperAddOrganizationInlineDialog:
    'newBoardHelperAddOrganizationInlineDialog',
  printAndExportBoardInlineDialog: 'printAndExportBoardInlineDialog',
  productPurchaseScreen: 'productPurchaseScreen',
  pupAttachmentSectionInlineDialog: 'pupAttachmentSectionInlineDialog',
  pupAttachmentsInlineDialog: 'pupAttachmentsInlineDialog',
  pupCardBackSectionInlineDialog: 'pupCardBackSectionInlineDialog',
  pupConfigurationInlineDialog: 'pupConfigurationInlineDialog',
  pupLimitBCUpsellInlineDialog: 'pupLimitBCUpsellInlineDialog',
  pupPopupInlineDialog: 'pupPopupInlineDialog',
  reactionSelectorInlineDialog: 'reactionSelectorInlineDialog',
  searchInlineDialog: 'searchInlineDialog',
  setPrimaryEmailInlineDialog: 'setPrimaryEmailInlineDialog',
  shareTemplateInlineDialog: 'shareTemplateInlineDialog',
  switchToYearlyBillingInlineDialog: 'switchToYearlyBillingInlineDialog',
  tacoTemplateTipsInlineDialog: 'tacoTemplateTipsInlineDialog',
  taxExemptionInlineDialog: 'taxExemptionInlineDialog',
  teamTemplatePicker: 'teamTemplatePicker',
  templateTipsInlineDialog: 'templateTipsInlineDialog',
  votingSettingsInlineDialog: 'votingSettingsInlineDialog',
  workspacesPreambleInlineDialog: 'workspacesPreambleInlineDialog',
  workspacesPreambleBoardInviteInlineDialog:
    'workspacesPreambleBoardInviteInlineDialog',
  workspacesPreambleAddToTeamInlineDialog:
    'workspacesPreambleAddToTeamInlineDialog',
} as const;

const sections = {
  teamTemplatePickerSection: 'teamTemplatePickerSection',
  twoFactorAuthSettings: 'twoFactorAuthSettings',
  yourItemsSection: 'yourItemsSection',
} as const;

// Modals are components that are independently brought to the foreground while
// dimming out the rest of the experience. They are NOT popovers!
const modals = {
  boardPowerUpDirectoryModal: 'boardPowerUpDirectoryModal',
  cancelBusinessClassModal: 'cancelBusinessClassModal',
  cancelTrelloGoldModal: 'cancelTrelloGoldModal',
  closedBoardsModal: 'closedBoardsModal',
  createBoardModal: 'createBoardModal',
  createFreeTeamModal: 'createFreeTeamModal',
  freeTeamRestrictionModal: 'freeTeamRestrictionModal',
  freeTrialModal: 'freeTrialModal',
  planSelectionModal: 'planSelectionModal',
} as const;

// Drawers are components that slide in from the side and take control of the
// screen, like the boards menu on the left.
const drawers = {
  boardsDrawer: 'boardsDrawer',
  boardMenuDrawer: 'boardMenuDrawer',
  boardSidebarDrawer: 'boardSidebarDrawer', // Deprecated, use a boardMenuDrawerScreen or the generic `boardMenuDrawer`
} as const;

// Banners are commonly displayed between the app header and the board header
const banners = {
  atlassianAccessAdBanner: 'atlassianAccessAdBanner',
  atlassianAccountAutomaticOnboarding: 'atlassianAccountAutomaticOnboarding',
  atlassianAccountAutomaticOnboardingBanner:
    'atlassianAccountAutomaticOnboardingBanner',
  atlassianAccountMigrationBanner: 'atlassianAccountMigrationBanner',
  atlassianAccountOnboardingBanner: 'atlassianAccountOnboardingBanner',
  boardLimitsDowngradeBanner: 'boardLimitsDowngradeBanner',
  browserWillBeUnsupportedBanner: 'browserWillBeUnsupportedBanner',
  emailHygieneBanner: 'emailHygieneBanner',
  emailVerificationBanner: 'emailVerificationBanner',
  enterpriseDeprovisioningBanner: 'enterpriseDeprovisioningBanner',
  enterpriseLicenseBanner: 'enterpriseLicenseBanner',
  freeTeamLimitWarningBanner: 'freeTeamLimitWarningBanner',
  freeTeamLimitRestrictedBanner: 'freeTeamLimitRestrictedBanner',
  freeTrialBanner: 'freeTrialBanner',
  personalBoardsOwnershipBanner: 'personalBoardsOwnershipBanner',
  invitedBanner: 'invitedBanner',
  loggedInPublicBoardBanner: 'loggedInPublicBoardBanner',
  newLocaleBanner: 'newLocaleBanner',
  overdueBanner: 'overdueBanner',
  setPasswordBanner: 'setPasswordBanner',
} as const;

// Screens that are tabs of the home page experience
const homeScreens = {
  boardsHomeScreen: 'boardsHomeScreen', // trello.com/user/boards
  memberHomeScreen: 'memberHomeScreen', // trello.com for logged in user
  templateGalleryScreen: 'templateGalleryScreen', // trello.com/templates
  organizationBoardsScreen: 'organizationBoardsScreen',
} as const;

// Screens are pages or tabs of an experience
const screens = {
  aaMigrationWizardCheckInboxScreen: 'aaMigrationWizardCheckInboxScreen',
  aaMigrationWizardLogInScreen: 'aaMigrationWizardLogInScreen',
  aaMigrationWizardCreateScreen: 'aaMigrationWizardCreateScreen',
  aaMigrationWizardEmailMismatchScreen: 'aaMigrationWizardEmailMismatchScreen',
  archiveScreen: 'archiveScreen',
  boardDirectoryScreen: 'boardDirectoryScreen',
  boardDirectoryFeaturedScreen: 'boardDirectoryFeaturedScreen',
  boardDirectoryPowerUpDetailsScreen: 'boardDirectoryPowerUpDetailsScreen',
  boardMenuDrawerAboutScreen: 'boardMenuDrawerAboutScreen',
  boardMenuDrawerActivityScreen: 'boardMenuDrawerActivityScreen',
  boardMenuDrawerArchiveScreen: 'boardMenuDrawerArchiveScreen',
  boardMenuDrawerBackgroundScreen: 'boardMenuDrawerBackgroundScreen',
  boardMenuDrawerBackgroundColorsScreen:
    'boardMenuDrawerBackgroundColorsScreen',
  boardMenuDrawerBackgroundPhotosScreen:
    'boardMenuDrawerBackgroundPhotosScreen',
  boardMenuDrawerCollectionsScreen: 'boardMenuDrawerCollectionsScreen',
  boardMenuDrawerDefaultScreen: 'boardMenuDrawerDefaultScreen',
  boardMenuDrawerFilterScreen: 'boardMenuDrawerFilterScreen',
  boardMenuDrawerLabelsScreen: 'boardMenuDrawerLabelsScreen',
  boardMenuDrawerMoreScreen: 'boardMenuDrawerMoreScreen',
  boardMenuDrawerSettingsScreen: 'boardMenuDrawerSettingsScreen',
  boardMenuDrawerStickersScreen: 'boardMenuDrawerStickersScreen',
  boardScreen: 'boardScreen', // Use for board
  businessClassSignupFormScreen: 'businessClassSignupFormScreen',
  calendarViewScreen: 'calendarViewScreen',
  cardDetailScreen: 'cardDetailScreen', // Use for cardback
  cardLabelsScreen: 'cardLabelsScreen',
  closeBoardScreen: 'closeBoardScreen', // After closing a board, before deleting
  emailHygieneAtlassianTrelloScreen: 'emailHygieneAtlassianTrelloScreen',
  emailHygieneAaMigrationScreen: 'emailHygieneAaMigrationScreen',
  emailHygieneConfirmEmailScreen: 'emailHygieneConfirmEmailScreen',
  emailHygieneChooseEmailScreen: 'emailHygieneChooseEmailScreen',
  emailHygieneClaimableWarningScreen: 'emailHygieneClaimableWarningScreen',
  emailHygieneConfirmationSentScreen: 'emailHygieneConfirmationSentScreen',
  emailHygieneErrorScreen: 'emailHygieneErrorScreen',
  emailHygieneThanksScreen: 'emailHygieneThanksScreen',
  instantSearchScreen: 'instantSearchScreen',
  labelEditScreen: 'labelEditScreen',
  memberBillingScreen: 'memberBillingScreen',
  moonshotBCFreeTrialUpsellScreen: 'moonshotBCFreeTrialUpsellScreen',
  moonshotCreateTeamScreen: 'moonshotCreateTeamScreen',
  moonshotInviteMembersScreen: 'moonshotInviteMembersScreen',
  moonshotPaymentScreen: 'moonshotPaymentScreen',
  moonshotPlanSelectionScreen: 'moonshotPlanSelectionScreen',
  moonshotSignupScreen: 'moonshotSignupScreen',
  multiBoardTableViewScreen: 'multiBoardTableViewScreen',
  newUserOrientationScreen: 'newUserOrientationScreen',
  nonEnterpriseTeamScreen: 'nonEnterpriseTeamScreen',
  profileAndVisibilitySettingsScreen: 'profileAndVisibilitySettingsScreen',
  publicDirectoryAllCategoriesScreen: 'publicDirectoryAllCategoriesScreen',
  publicDirectoryCategoryScreen: 'publicDirectoryCategoryScreen',
  publicDirectoryHomeScreen: 'publicDirectoryHomeScreen',
  publicDirectoryPowerUpDetailsScreen: 'publicDirectoryPowerUpDetailsScreen',
  publicDirectoryScreen: 'publicDirectoryScreen',
  publicDirectorySearchResultsScreen: 'publicDirectorySearchResultsScreen',
  publicPowerUpAddToBoardScreen: 'publicPowerUpAddToBoardScreen',
  publicPowerUpDetailsScreen: 'publicPowerUpDetailsScreen',
  pupAttachmentSuggestionSection: 'pupAttachmentSuggestionSection',
  savedSearchesScreen: 'savedSearchesScreen',
  savedSearchScreen: 'savedSearchScreen',
  searchHelpScreen: 'searchHelpScreen',
  searchResultsScreen: 'searchResultsScreen',
  shortcutsScreen: 'shortcutsScreen',
  sortListInlineDialog: 'sortListInlineDialog',
  teamBillingScreen: 'teamBillingScreen',
  teamScreen: 'teamScreen',
  teamMembersScreen: 'teamMembersScreen',
  teamSettingsScreen: 'teamSettingsScreen',
  templateCategoryScreen: 'templateCategoryScreen',
  templateStoryPageScreen: 'templateStoryPageScreen',
  trelloGoldSignupFormScreen: 'trelloGoldSignupFormScreen',
  orgProfileEditScreen: 'orgProfileEditScreen',
  unknownScreen: 'unknownScreen',
} as const;

const jswCrossflowSources = {
  jswLearnMoreInlineDialog: 'jswLearnMoreInlineDialog',
} as const;

const packages = {
  '@atlassiansox/feature-flag-web-client':
    '@atlassiansox/feature-flag-web-client',
  '@trello/atlassian-analytics': '@trello/atlassian-analytics',
  '@trello/feature-flag-client': '@trello/feature-flag-client',
  '@trello/graphql': '@trello/graphql',
} as const;

const otherSources = {
  addPowerUpButton: 'addPowerUpButton',
  appHeader: 'appHeader', // The global Trello header
  appStartup: 'appStartup',
  atlassianAccountOnboardingOverlay: 'atlassianAccountOnboardingOverlay',
  atlassianAccountAutomaticOnboardingOverlay:
    'atlassianAccountAutomaticOnboardingOverlay',
  atlassianAdministrationPage: 'atlassianAdministrationPage',
  atlassianAutomaticOnboardingUpdateAccountModal:
    'atlassianAutomaticOnboardingUpdateAccountModal',
  atlassianAutomaticOnboardingProfileModal:
    'atlassianAutomaticOnboardingProfileModal',
  atlassianAutomaticOnboardingConfirmationModal:
    'atlassianAutomaticOnboardingConfirmationModal',
  atlassianAutomaticOnboardingEmailMismatchModal:
    'atlassianAutomaticOnboardingEmailMismatchModal',
  atlassianSwitcher: 'atlassianSwitcher',
  avalaraCertCaptureIntegration: 'avalaraCertCaptureIntegration',
  boardDirectory: 'boardDirectory',
  boardDirectorySearch: 'boardDirectorySearch',
  boardMap: 'boardMap',
  cardLabelFilter: 'cardLabelFilter',
  crossFlowOverlay: 'crossFlowOverlay',
  closeBoardLink: 'closeBoardLink',
  externalScriptLoader: 'externalScriptLoader',
  powerUpCardFromUrl: 'powerUpCardFromUrl',
  powerUpFormatUrl: 'powerUpFormatUrl',
  globalErrorHandler: 'globalErrorHandler',
  'lib:pluginBehavioralAnalytics': 'lib:pluginBehavioralAnalytics',
  'lib:featureFlagWebClient': 'lib:featureFlagWebClient',
  iframeIO: 'iframeIO',
  listFooter: 'listFooter',
  listHeader: 'listHeader',
  newUserOrientationCard: 'newUserOrientationCard',
  onboardingDialog: 'onboardingDialog',
  pluginSuggestionSection: 'pluginSuggestionSection',
  powerUpCard: 'powerUpCard',
  stickerHoverView: 'stickerHoverView',
  stickerEditView: 'stickerEditView',
  templates: 'templates',
  templatesTemplateCategory: 'templatesTemplateCategory',
  templatesTemplateStory: 'templatesTemplateStory',
  templatesTemplatesFeatured: 'templatesTemplatesFeatured',
  teamfulCollaborationSuccessMessage: 'teamfulCollaborationSuccessMessage',
  // This is current being used for the generic global error handler. The intention is to eventually replace 'unknown'
  // with a source automatically determined based on the URL. Using 'unknown' should be avoided wherever possible.
  unknown: 'unknown',
} as const;

export const Source = {
  ...inlineDialogs,
  ...modals,
  ...drawers,
  ...banners,
  ...homeScreens,
  ...screens,
  ...sections,
  ...jswCrossflowSources,
  ...packages,
  ...otherSources,
} as const;

export type SourceType = typeof Source[keyof typeof Source];
